/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiError,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    DiscordAuthResponse,
    DiscordAuthResponseFromJSON,
    DiscordAuthResponseToJSON,
    DiscordInfoResponse,
    DiscordInfoResponseFromJSON,
    DiscordInfoResponseToJSON,
    GetConnectedAccountResponse,
    GetConnectedAccountResponseFromJSON,
    GetConnectedAccountResponseToJSON,
    GetDevourStatsResponse,
    GetDevourStatsResponseFromJSON,
    GetDevourStatsResponseToJSON,
    InlineObject10,
    InlineObject10FromJSON,
    InlineObject10ToJSON,
    InlineObject11,
    InlineObject11FromJSON,
    InlineObject11ToJSON,
    InlineObject7,
    InlineObject7FromJSON,
    InlineObject7ToJSON,
    InlineObject8,
    InlineObject8FromJSON,
    InlineObject8ToJSON,
    InlineObject9,
    InlineObject9FromJSON,
    InlineObject9ToJSON,
    InlineResponse20013,
    InlineResponse20013FromJSON,
    InlineResponse20013ToJSON,
    RewardDailyXpBody,
    RewardDailyXpBodyFromJSON,
    RewardDailyXpBodyToJSON,
} from '../models';

export interface DiscordAuthRedirectRequest {
    inlineObject7: InlineObject7;
}

export interface DiscordRelayMessageDeletePostRequest {
    inlineObject8: InlineObject8;
}

export interface DiscordRelayMessageHistoryPostRequest {
    inlineObject9: InlineObject9;
}

export interface DiscordRelayMessagePostRequest {
    inlineObject11: InlineObject11;
}

export interface DiscordRelayMessageUpdatePostRequest {
    inlineObject10: InlineObject10;
}

export interface GetConnectedAccountRequest {
    discordMemberId: string;
}

export interface GetDevourStatsRequest {
    discordMemberId: string;
}

export interface RewardDailyXpRequest {
    rewardDailyXpBody: RewardDailyXpBody;
}

/**
 * DiscordApi - interface
 * @export
 * @interface DiscordApiInterface
 */
export interface DiscordApiInterface {
    /**
     * Disconnects the discord account associated with the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    disconnectDiscordAccountRaw(): Promise<runtime.ApiResponse<boolean>>;

    /**
     * Disconnects the discord account associated with the user
     */
    disconnectDiscordAccount(): Promise<boolean>;

    /**
     * Fetches the Discord OAuth2 URL for account linking.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    discordAuthRaw(): Promise<runtime.ApiResponse<DiscordAuthResponse>>;

    /**
     * Fetches the Discord OAuth2 URL for account linking.
     */
    discordAuth(): Promise<DiscordAuthResponse>;

    /**
     * Handles the redirect from Discord OAuth2 and processes the authorization code.
     * @param {InlineObject7} inlineObject7 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    discordAuthRedirectRaw(requestParameters: DiscordAuthRedirectRequest): Promise<runtime.ApiResponse<boolean>>;

    /**
     * Handles the redirect from Discord OAuth2 and processes the authorization code.
     */
    discordAuthRedirect(requestParameters: DiscordAuthRedirectRequest): Promise<boolean>;

    /**
     * Used by Discord bot to broadcast message deletions to web clients
     * @summary Relay a Discord message deletion to connected web clients
     * @param {InlineObject8} inlineObject8 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    discordRelayMessageDeletePostRaw(requestParameters: DiscordRelayMessageDeletePostRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by Discord bot to broadcast message deletions to web clients
     * Relay a Discord message deletion to connected web clients
     */
    discordRelayMessageDeletePost(requestParameters: DiscordRelayMessageDeletePostRequest): Promise<void>;

    /**
     * Used by Discord bot to send initial message history when a client subscribes to a channel
     * @summary Send message history to a specific client
     * @param {InlineObject9} inlineObject9 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    discordRelayMessageHistoryPostRaw(requestParameters: DiscordRelayMessageHistoryPostRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by Discord bot to send initial message history when a client subscribes to a channel
     * Send message history to a specific client
     */
    discordRelayMessageHistoryPost(requestParameters: DiscordRelayMessageHistoryPostRequest): Promise<void>;

    /**
     * Used by Discord bot to broadcast messages to web clients subscribed to specific channels
     * @summary Relay a Discord message to connected web clients
     * @param {InlineObject11} inlineObject11 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    discordRelayMessagePostRaw(requestParameters: DiscordRelayMessagePostRequest): Promise<runtime.ApiResponse<InlineResponse20013>>;

    /**
     * Used by Discord bot to broadcast messages to web clients subscribed to specific channels
     * Relay a Discord message to connected web clients
     */
    discordRelayMessagePost(requestParameters: DiscordRelayMessagePostRequest): Promise<InlineResponse20013>;

    /**
     * Used by Discord bot to broadcast message edits to web clients
     * @summary Relay a Discord message edit/update to connected web clients
     * @param {InlineObject10} inlineObject10 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    discordRelayMessageUpdatePostRaw(requestParameters: DiscordRelayMessageUpdatePostRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Used by Discord bot to broadcast message edits to web clients
     * Relay a Discord message edit/update to connected web clients
     */
    discordRelayMessageUpdatePost(requestParameters: DiscordRelayMessageUpdatePostRequest): Promise<void>;

    /**
     * 
     * @summary Retrieves the user ID associated with a given Discord member ID
     * @param {string} discordMemberId The Discord member ID to check for connection
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    getConnectedAccountRaw(requestParameters: GetConnectedAccountRequest): Promise<runtime.ApiResponse<GetConnectedAccountResponse>>;

    /**
     * Retrieves the user ID associated with a given Discord member ID
     */
    getConnectedAccount(requestParameters: GetConnectedAccountRequest): Promise<GetConnectedAccountResponse>;

    /**
     * 
     * @summary Retrieve GoVIP level and experience points for a Discord member
     * @param {string} discordMemberId The Discord member ID for retrieving Devour stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    getDevourStatsRaw(requestParameters: GetDevourStatsRequest): Promise<runtime.ApiResponse<GetDevourStatsResponse>>;

    /**
     * Retrieve GoVIP level and experience points for a Discord member
     */
    getDevourStats(requestParameters: GetDevourStatsRequest): Promise<GetDevourStatsResponse>;

    /**
     * Fetches the Discord account linked with the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    getDiscordAccountRaw(): Promise<runtime.ApiResponse<DiscordInfoResponse>>;

    /**
     * Fetches the Discord account linked with the user
     */
    getDiscordAccount(): Promise<DiscordInfoResponse>;

    /**
     * 
     * @summary Rewards daily XP to the specified Discord member
     * @param {RewardDailyXpBody} rewardDailyXpBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DiscordApiInterface
     */
    rewardDailyXpRaw(requestParameters: RewardDailyXpRequest): Promise<runtime.ApiResponse<number>>;

    /**
     * Rewards daily XP to the specified Discord member
     */
    rewardDailyXp(requestParameters: RewardDailyXpRequest): Promise<number>;

}

/**
 * no description
 */
export class DiscordApi extends runtime.BaseAPI implements DiscordApiInterface {

    /**
     * Disconnects the discord account associated with the user
     */
    async disconnectDiscordAccountRaw(): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/discord/account/disconnect`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Disconnects the discord account associated with the user
     */
    async disconnectDiscordAccount(): Promise<boolean> {
        const response = await this.disconnectDiscordAccountRaw();
        return await response.value();
    }

    /**
     * Fetches the Discord OAuth2 URL for account linking.
     */
    async discordAuthRaw(): Promise<runtime.ApiResponse<DiscordAuthResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/link-discord`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscordAuthResponseFromJSON(jsonValue));
    }

    /**
     * Fetches the Discord OAuth2 URL for account linking.
     */
    async discordAuth(): Promise<DiscordAuthResponse> {
        const response = await this.discordAuthRaw();
        return await response.value();
    }

    /**
     * Handles the redirect from Discord OAuth2 and processes the authorization code.
     */
    async discordAuthRedirectRaw(requestParameters: DiscordAuthRedirectRequest): Promise<runtime.ApiResponse<boolean>> {
        if (requestParameters.inlineObject7 === null || requestParameters.inlineObject7 === undefined) {
            throw new runtime.RequiredError('inlineObject7','Required parameter requestParameters.inlineObject7 was null or undefined when calling discordAuthRedirect.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/link-discord/callback`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject7ToJSON(requestParameters.inlineObject7),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Handles the redirect from Discord OAuth2 and processes the authorization code.
     */
    async discordAuthRedirect(requestParameters: DiscordAuthRedirectRequest): Promise<boolean> {
        const response = await this.discordAuthRedirectRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used by Discord bot to broadcast message deletions to web clients
     * Relay a Discord message deletion to connected web clients
     */
    async discordRelayMessageDeletePostRaw(requestParameters: DiscordRelayMessageDeletePostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.inlineObject8 === null || requestParameters.inlineObject8 === undefined) {
            throw new runtime.RequiredError('inlineObject8','Required parameter requestParameters.inlineObject8 was null or undefined when calling discordRelayMessageDeletePost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/discord/relay-message-delete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject8ToJSON(requestParameters.inlineObject8),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by Discord bot to broadcast message deletions to web clients
     * Relay a Discord message deletion to connected web clients
     */
    async discordRelayMessageDeletePost(requestParameters: DiscordRelayMessageDeletePostRequest): Promise<void> {
        await this.discordRelayMessageDeletePostRaw(requestParameters);
    }

    /**
     * Used by Discord bot to send initial message history when a client subscribes to a channel
     * Send message history to a specific client
     */
    async discordRelayMessageHistoryPostRaw(requestParameters: DiscordRelayMessageHistoryPostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.inlineObject9 === null || requestParameters.inlineObject9 === undefined) {
            throw new runtime.RequiredError('inlineObject9','Required parameter requestParameters.inlineObject9 was null or undefined when calling discordRelayMessageHistoryPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/discord/relay-message-history`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject9ToJSON(requestParameters.inlineObject9),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by Discord bot to send initial message history when a client subscribes to a channel
     * Send message history to a specific client
     */
    async discordRelayMessageHistoryPost(requestParameters: DiscordRelayMessageHistoryPostRequest): Promise<void> {
        await this.discordRelayMessageHistoryPostRaw(requestParameters);
    }

    /**
     * Used by Discord bot to broadcast messages to web clients subscribed to specific channels
     * Relay a Discord message to connected web clients
     */
    async discordRelayMessagePostRaw(requestParameters: DiscordRelayMessagePostRequest): Promise<runtime.ApiResponse<InlineResponse20013>> {
        if (requestParameters.inlineObject11 === null || requestParameters.inlineObject11 === undefined) {
            throw new runtime.RequiredError('inlineObject11','Required parameter requestParameters.inlineObject11 was null or undefined when calling discordRelayMessagePost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/discord/relay-message`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject11ToJSON(requestParameters.inlineObject11),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse20013FromJSON(jsonValue));
    }

    /**
     * Used by Discord bot to broadcast messages to web clients subscribed to specific channels
     * Relay a Discord message to connected web clients
     */
    async discordRelayMessagePost(requestParameters: DiscordRelayMessagePostRequest): Promise<InlineResponse20013> {
        const response = await this.discordRelayMessagePostRaw(requestParameters);
        return await response.value();
    }

    /**
     * Used by Discord bot to broadcast message edits to web clients
     * Relay a Discord message edit/update to connected web clients
     */
    async discordRelayMessageUpdatePostRaw(requestParameters: DiscordRelayMessageUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.inlineObject10 === null || requestParameters.inlineObject10 === undefined) {
            throw new runtime.RequiredError('inlineObject10','Required parameter requestParameters.inlineObject10 was null or undefined when calling discordRelayMessageUpdatePost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/discord/relay-message-update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject10ToJSON(requestParameters.inlineObject10),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used by Discord bot to broadcast message edits to web clients
     * Relay a Discord message edit/update to connected web clients
     */
    async discordRelayMessageUpdatePost(requestParameters: DiscordRelayMessageUpdatePostRequest): Promise<void> {
        await this.discordRelayMessageUpdatePostRaw(requestParameters);
    }

    /**
     * Retrieves the user ID associated with a given Discord member ID
     */
    async getConnectedAccountRaw(requestParameters: GetConnectedAccountRequest): Promise<runtime.ApiResponse<GetConnectedAccountResponse>> {
        if (requestParameters.discordMemberId === null || requestParameters.discordMemberId === undefined) {
            throw new runtime.RequiredError('discordMemberId','Required parameter requestParameters.discordMemberId was null or undefined when calling getConnectedAccount.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.discordMemberId !== undefined) {
            queryParameters['discordMemberId'] = requestParameters.discordMemberId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/discord/integration/get_connected_account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetConnectedAccountResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the user ID associated with a given Discord member ID
     */
    async getConnectedAccount(requestParameters: GetConnectedAccountRequest): Promise<GetConnectedAccountResponse> {
        const response = await this.getConnectedAccountRaw(requestParameters);
        return await response.value();
    }

    /**
     * Retrieve GoVIP level and experience points for a Discord member
     */
    async getDevourStatsRaw(requestParameters: GetDevourStatsRequest): Promise<runtime.ApiResponse<GetDevourStatsResponse>> {
        if (requestParameters.discordMemberId === null || requestParameters.discordMemberId === undefined) {
            throw new runtime.RequiredError('discordMemberId','Required parameter requestParameters.discordMemberId was null or undefined when calling getDevourStats.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.discordMemberId !== undefined) {
            queryParameters['discordMemberId'] = requestParameters.discordMemberId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/discord/integration/get_devour_stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDevourStatsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve GoVIP level and experience points for a Discord member
     */
    async getDevourStats(requestParameters: GetDevourStatsRequest): Promise<GetDevourStatsResponse> {
        const response = await this.getDevourStatsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Fetches the Discord account linked with the user
     */
    async getDiscordAccountRaw(): Promise<runtime.ApiResponse<DiscordInfoResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("User", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/discord/account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscordInfoResponseFromJSON(jsonValue));
    }

    /**
     * Fetches the Discord account linked with the user
     */
    async getDiscordAccount(): Promise<DiscordInfoResponse> {
        const response = await this.getDiscordAccountRaw();
        return await response.value();
    }

    /**
     * Rewards daily XP to the specified Discord member
     */
    async rewardDailyXpRaw(requestParameters: RewardDailyXpRequest): Promise<runtime.ApiResponse<number>> {
        if (requestParameters.rewardDailyXpBody === null || requestParameters.rewardDailyXpBody === undefined) {
            throw new runtime.RequiredError('rewardDailyXpBody','Required parameter requestParameters.rewardDailyXpBody was null or undefined when calling rewardDailyXp.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/discord/integration/reward_daily_xp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RewardDailyXpBodyToJSON(requestParameters.rewardDailyXpBody),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Rewards daily XP to the specified Discord member
     */
    async rewardDailyXp(requestParameters: RewardDailyXpRequest): Promise<number> {
        const response = await this.rewardDailyXpRaw(requestParameters);
        return await response.value();
    }

}
